import { Store } from "@tanstack/react-store";

export const localStorageItems = [
  {
    localStorageKey: "psmOnboardingTourStep",
    type: "number",
  },
] as const satisfies readonly { localStorageKey: string; type: string }[];

type Item = (typeof localStorageItems)[number];
export type LocalStorageItemState = {
  [K in Item as K["localStorageKey"]]?: K["type"] extends "boolean"
    ? boolean
    : K["type"] extends "string"
      ? string
      : K["type"] extends "number"
        ? number
        : never;
};

const parseNumberItem = (value: string | null): number | undefined => {
  if (value === undefined || value === null) return;

  return Number(value);
};

function loadInitialState(): LocalStorageItemState {
  const initialState: LocalStorageItemState = {};

  localStorageItems.forEach((item) => {
    const value = localStorage.getItem(item.localStorageKey);

    const parsedValue = parseNumberItem(value);
    if (parsedValue !== undefined) initialState[item.localStorageKey] = parsedValue;
  });

  return initialState;
}

export const localStorageStore = new Store<LocalStorageItemState>(loadInitialState());

export const setLocalStorageByKey = <K extends keyof LocalStorageItemState>(
  localStorageKey: K,
  value: LocalStorageItemState[K]
) => {
  // Remove from localStorage if value is empty or undefined
  if (value === undefined || value === null) {
    localStorage.removeItem(localStorageKey as string);
  } else {
    localStorage.setItem(localStorageKey as string, String(value));
  }
  localStorageStore.setState((state) => ({
    ...state,
    [localStorageKey]: value,
  }));
};
